import { ErrorCodeMap } from './error-code-map.types';

/**
 * user-service `ExceptionErrorCodes` (range 4001-4022).
 * Generated from the backend registry; see error-codes.md.
 */
export const USER_ERROR_CODES: ErrorCodeMap = {
  4001: { key: 'permissionInvalidId', surface: false },
  4002: { key: 'roleInvalidId', surface: false },
  4003: { key: 'paymentAccountInvalidId', surface: false },
  4004: { key: 'paymentAccountAlreadyExists', surface: true },
  4005: { key: 'userNotFound', surface: true },
  4006: { key: 'userInvalidBirthdate', surface: true },
  4007: { key: 'userInvalidBirthplace', surface: true },
  4008: { key: 'userInvalidEmail', surface: true },
  4009: { key: 'userInvalidFirstName', surface: true },
  4010: { key: 'userInvalidGender', surface: true },
  4011: { key: 'userInvalidId', surface: false },
  4012: { key: 'userInvalidLanguage', surface: true },
  4013: { key: 'userInvalidLastName', surface: true },
  4014: { key: 'userInvalidPhone', surface: true },
  4015: { key: 'userInvalidProfileImage', surface: true },
  4016: { key: 'userInvalidUsername', surface: true },
  4017: { key: 'companyInvalidId', surface: false },
  4018: { key: 'companyNotFound', surface: true },
  4019: { key: 'roleNotFound', surface: true },
  4020: { key: 'userInvalidFilter', surface: false },
  4021: { key: 'userAlreadyExists', surface: true },
  4022: { key: 'userCouldNotBeAddedToTheCompany', surface: true },
};
